import { clubbiStyled } from 'clubbi-ui'

export const StyledLinkToHome = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  width: '100%',
  paddingLeft: '20px',
  marginTop: 0,
}))
